// extracted by mini-css-extract-plugin
export default {"text":"MakeAPayment_text__9ssiC","contactTitle":"MakeAPayment_contactTitle__m6nfQ","contactSubtitle":"MakeAPayment_contactSubtitle__CbwQh","contact":"MakeAPayment_contact__KrwL7"};